import { ChangeEvent, useContext } from "react";
import { SwitchInput } from "@remo-co/ui-core/src/components/SwitchInput";
import { Box } from "@remo-co/ui-core/src/components/Box";
import { useI18n } from "i18n";
import useCompany from "modules/company/hooks/useCompany";
import useCompanySettingsActions from "modules/companySettings/hooks/useCompanySettingsActions";
import useNotificationActions from "modules/notification/hooks/useNotificationActions";
import { Events, TRACKING_CONTEXT } from "modules/tracking";
import { updateCompanySettings } from "services/apiService/apis";
import { selectDisableFreshchatWidget } from "modules/companySettings/redux/selectors";
import { useSelector } from "react-redux";
import { setSettings } from "modules/settings/redux/slice";

interface Props {
  enabledAgencyWhiteLabelling: boolean;
}

export const DisableFreshchatWidget = ({
  enabledAgencyWhiteLabelling,
}: Props) => {
  const { track } = useContext(TRACKING_CONTEXT);
  const { setCompanySettings } = useCompanySettingsActions();
  const { t } = useI18n(["common", "settings"]);
  const { company } = useCompany();
  const { addErrorNotification, addSuccessNotification } =
    useNotificationActions();
  const disableFreshchatWidget = useSelector(selectDisableFreshchatWidget);

  const saveChanges = async (
    _: ChangeEvent,
    incomingDisableFreshchatWidget: boolean,
  ) => {
    if (company && company.id) {
      const res = await updateCompanySettings(company.id, {
        disableFreshchatWidget: incomingDisableFreshchatWidget,
        company: company.id,
      });

      if (!res.isSuccess) {
        addErrorNotification({
          message: t("settings:agency.white.label.freschat.update.error"),
        });

        return;
      }

      if (res.companySettings) {
        setCompanySettings(res.companySettings);
        setSettings({
          disableFreshchatWidget: incomingDisableFreshchatWidget,
        });
      }
      if (incomingDisableFreshchatWidget) {
        track(Events.AGENCY_WHITE_LABEL_FRESHCHAT_WIDGET_TOGGLED_OFF, {
          companyIds: company.id,
        });
      } else {
        track(Events.AGENCY_WHITE_LABEL_FRESHCHAT_WIDGET_TOGGLED_ON, {
          companyIds: company.id,
        });
      }
      addSuccessNotification({
        message: t("settings:agency.white.label.freshchat.update.success"),
      });
    }
  };

  return (
    <Box>
      <SwitchInput
        id="disable-freshchat-toggle"
        label={t("settings:disable.freshchat.widget")}
        checked={enabledAgencyWhiteLabelling ? disableFreshchatWidget : false}
        disabled={!enabledAgencyWhiteLabelling}
        onChange={saveChanges}
      />
    </Box>
  );
};
